import { IColorByValueConfig } from 'app/services/api/colorByValue'
import OverlayScrollbar from 'common/components/OverlayScrollBar'
import CBVThemeIcon from 'features/DataManagement/Components/ColorByValue/CBVThemeIcon'

interface IColorByValueCustomizeColorModalSidebar {
  config: IColorByValueConfig
  setConfig: (config: IColorByValueConfig) => void
}

const Sidebar = ({
  config,
  setConfig
}: IColorByValueCustomizeColorModalSidebar) => {
  const changeSelection = (attrId: string): void => {
    setConfig({
      ...config,
      selectedAttributeId: attrId
    })
  }

  return (
    <div className='mx-3 mb-2 mt-4 flex min-w-[18rem] flex-col'>
      <div className='my-2 ml-3 mr-2 font-semibold leading-none'>
        {config?.viewName}
      </div>
      <div
        className={[
          'my-4 ml-3 mr-2',
          'uppercase leading-none text-gray-500',
          'font-medium tracking-[0.03em]'
        ].join(' ')}
      >
        Attribute
      </div>
      <OverlayScrollbar>
        {config?.attributesMap.map((attr) => {
          return (
            <button
              className='block w-full'
              key={attr.attributeId}
              onClick={() => changeSelection(attr.attributeId)}
            >
              <div
                className={[
                  'flex items-center',
                  attr.attributeId === config.selectedAttributeId
                    ? 'bg-lighthouseBlue-100'
                    : '',
                  'bg-opacity-40 p-2'
                ].join(' ')}
              >
                <CBVThemeIcon
                  className='h-6 w-6 rounded border border-white'
                  themeName={attr.iconTheme}
                />
                <div className='ml-4 font-medium'>{attr.attributeName}</div>
              </div>
            </button>
          )
        })}
      </OverlayScrollbar>
    </div>
  )
}

export default Sidebar
